import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ElementLocale from 'element-ui/lib/locale'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementFrLocale from 'element-ui/lib/locale/lang/fr'

import en from './locales/en.json'
import fr from './locales/fr.json'
import he from './locales/he.json'

Vue.use(VueI18n)

const SUPPORTED_LOCALES = ['en', 'fr', 'he']

function detectLocale () {
  const stored = localStorage.getItem('faice-locale')
  if (stored && SUPPORTED_LOCALES.includes(stored)) return stored

  const nav = (navigator.language || '').toLowerCase()
  if (nav.startsWith('fr')) return 'fr'
  if (nav.startsWith('he')) return 'he'
  return 'en'
}

const locale = detectLocale()

// Persist detected locale so it survives across sessions even if the user never
// explicitly picks a language via the selector
if (!localStorage.getItem('faice-locale')) {
  localStorage.setItem('faice-locale', locale)
}

const i18n = new VueI18n({
  locale,
  fallbackLocale: 'en',
  silentTranslationWarn: true,
  messages: {
    en: { ...en, ...elementEnLocale },
    fr: { ...fr, ...elementFrLocale },
    he: { ...he, ...elementEnLocale } // Element UI has no Hebrew locale, fallback to EN
  }
})

// Bridge Element UI to vue-i18n so Element components follow the active locale
ElementLocale.i18n((key, value) => i18n.t(key, value))

export default i18n
